"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartTransformation = exports.renderHighCharts = void 0;
var tslib_1 = require("tslib");
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_ui_1 = require("@gooddata/sdk-ui");
var chartOptionsBuilder_1 = require("./chartTypes/_chartOptions/chartOptionsBuilder");
var highChartsCreators_1 = require("./chartTypes/_chartCreators/highChartsCreators");
var HighChartsRenderer_1 = require("./adapter/HighChartsRenderer");
var HighChartsMeasuredRenderer_1 = require("./adapter/HighChartsMeasuredRenderer");
var legendBuilder_1 = tslib_1.__importDefault(require("./adapter/legendBuilder"));
var noop_1 = tslib_1.__importDefault(require("lodash/noop"));
var isEqual_1 = tslib_1.__importDefault(require("lodash/isEqual"));
var isFunction_1 = tslib_1.__importDefault(require("lodash/isFunction"));
var omitBy_1 = tslib_1.__importDefault(require("lodash/omitBy"));
var react_intl_1 = require("react-intl");
var chartLimits_1 = require("./chartTypes/_chartOptions/chartLimits");
var sdk_ui_theme_provider_1 = require("@gooddata/sdk-ui-theme-provider");
var lib_1 = tslib_1.__importDefault(require("./lib"));
var common_1 = require("./chartTypes/_util/common");
function renderHighCharts(props) {
    var childrenRenderer = function (contentRect) { return (react_1.default.createElement(HighChartsRenderer_1.HighChartsRenderer, tslib_1.__assign({ contentRect: contentRect }, props))); };
    return react_1.default.createElement(HighChartsMeasuredRenderer_1.HighChartsMeasuredRenderer, { childrenRenderer: childrenRenderer });
}
exports.renderHighCharts = renderHighCharts;
var ChartTransformationImpl = function (props) {
    var config = props.config, _a = props.renderer, renderer = _a === void 0 ? renderHighCharts : _a, dataView = props.dataView, height = props.height, width = props.width, _b = props.afterRender, afterRender = _b === void 0 ? noop_1.default : _b, _c = props.onDrill, onDrill = _c === void 0 ? function () { return true; } : _c, _d = props.onLegendReady, onLegendReady = _d === void 0 ? noop_1.default : _d, locale = props.locale, intl = props.intl, theme = props.theme, numericSymbols = props.numericSymbols, _e = props.drillableItems, drillableItems = _e === void 0 ? [] : _e, onDataTooLarge = props.onDataTooLarge, _f = props.onNegativeValues, onNegativeValues = _f === void 0 ? null : _f, _g = props.pushData, pushData = _g === void 0 ? noop_1.default : _g;
    var visType = config.type;
    var drillablePredicates = sdk_ui_1.convertDrillableItemsToPredicates(drillableItems);
    var chartOptions = chartOptionsBuilder_1.getChartOptions(dataView, config, drillablePredicates, sdk_ui_1.emptyHeaderTitleFromIntl(intl), theme);
    var legendOptions = legendBuilder_1.default(config.legend, chartOptions);
    var validationResult = chartLimits_1.validateData(config.limits, chartOptions);
    var drillConfig = { dataView: dataView, onDrill: onDrill };
    var hcOptions = highChartsCreators_1.getHighchartsOptions(chartOptions, drillConfig, config, dataView.definition, intl, theme);
    var rendererProps = {
        chartOptions: chartOptions,
        hcOptions: hcOptions,
        height: height,
        width: width,
        afterRender: afterRender,
        onLegendReady: onLegendReady,
        locale: locale,
        legend: legendOptions,
        theme: theme,
    };
    if (validationResult.dataTooLarge) {
        // always force onDataTooLarge error handling
        ts_invariant_1.default(onDataTooLarge, "Visualization's onDataTooLarge callback is missing.");
        onDataTooLarge(chartOptions);
    }
    else if (validationResult.hasNegativeValue) {
        // ignore hasNegativeValue if validation already fails on dataTooLarge
        // force onNegativeValues error handling only for pie chart.
        // hasNegativeValue can be true only for pie chart.
        ts_invariant_1.default(onNegativeValues, '"onNegativeValues" callback required for pie chart transformation is missing.');
        onNegativeValues(chartOptions);
    }
    pushData({
        propertiesMeta: {
            legend_enabled: legendOptions.toggleEnabled,
        },
        colors: {
            colorAssignments: chartOptions.colorAssignments,
            colorPalette: chartOptions.colorPalette,
        },
    });
    if (!common_1.isChartSupported(visType)) {
        ts_invariant_1.default(false, "Unknown visualization type: " + visType + ". Supported visualization types: " + common_1.stringifyChartTypes());
    }
    if (numericSymbols === null || numericSymbols === void 0 ? void 0 : numericSymbols.length) {
        lib_1.default.setOptions({
            lang: {
                numericSymbols: numericSymbols,
            },
        });
    }
    if (validationResult.dataTooLarge || validationResult.hasNegativeValue) {
        return null;
    }
    var resetZoomButtonTooltip = intl
        ? intl.formatMessage({ id: "visualization.tooltip.resetZoom" })
        : null;
    return renderer(tslib_1.__assign(tslib_1.__assign({}, rendererProps), { chartRenderer: HighChartsRenderer_1.renderChart, legendRenderer: HighChartsRenderer_1.renderLegend, resetZoomButtonTooltip: resetZoomButtonTooltip }));
};
/**
 * @internal
 */
var ChartTransformationWithInjectedProps = react_intl_1.injectIntl(sdk_ui_theme_provider_1.withTheme(ChartTransformationImpl));
exports.ChartTransformation = react_1.default.memo(ChartTransformationWithInjectedProps, function (props, nextProps) {
    return isEqual_1.default(omitBy_1.default(props, isFunction_1.default), omitBy_1.default(nextProps, isFunction_1.default));
});
//# sourceMappingURL=ChartTransformation.js.map